<ng-container *ngIf="isLoading else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>


<ng-template #pageContent>

	<div class="container-fluid justify-content-center vh-100 d-flex p-0 m-0">
		<div class="row w-100 h-100 g-0">
          <div class="col-md-6 d-md-block p-0">
              <div class="auth-left-image">
                  <img src="assets/images/login.jpg" class="img-fluid bg-img" alt="user-image"/>

                   <div class="overlay"></div>
                       <div class="content">

         	  <img src="assets/images/logo_white.png" class="img-fluid logo" alt="App Logo" routerLink="/"  />

             <span class="badge">
		         <i class="bi bi-stars"></i>
		        Transform Your Career</span>
                 <h1> Your Path to <br /> Career Success</h1>

  				  <p class="subtitle">
    			  Join thousands of students who have transformed their careers with our
    			  comprehensive learning platform.
    			</p>

    <div class="features">
      <div class="feature-card">
        <i class="bi bi-journal-text"></i>
        <div>
          <h6>Professional Courses</h6>
          <p>Unlimited access to industry-relevant courses</p>
        </div>
      </div>

      <div class="feature-card">
        <i class="bi bi-clipboard-check"></i>
        <div>
          <h6>Placement Prep</h6>
          <p>Aptitude tests & interview preparation</p>
        </div>
      </div>

      <div class="feature-card">
        <i class="bi bi-mic"></i>
        <div>
          <h6>AI Interview Coach</h6>
          <p>Practice with AI-powered mock interviews</p>
        </div>
      </div>

      <div class="feature-card">
        <i class="bi bi-person-video3"></i>
        <div>
          <h6>Expert Mentorship</h6>
          <p>Get guidance from industry Professional</p>
        </div>
      </div>

	  <div class="feature-card">
        <i class="bi bi-graph-up"></i>
        <div>
          <h6>Track Progress</h6>
          <p>Monitor your growth with analytics</p>
        </div>
      </div>
    </div>
  </div>
</div>
	</div>

			<div class="col-md-6 d-flex flex-column justify-content-center">
				<div class="text-center mb-3">
					<img src="assets/images/lock.png" class="img-fluid lock-img">
				</div>
				<h2 class="text-center create-account">Set New Password</h2>
				<p class="text-center sub-head">Enter your new password to complete your reset process</p>

				<form [formGroup]="form" (ngSubmit)="onSubmit()">
					<div class="col-md-10 offset-md-1 mb-3">
						<div class="floating-label-wrapper">
							<i class="bi bi-lock input-icon"></i>

							<input [type]="showPassword ? 'text' : 'password'" formControlName="password"
								class="form-control floating-input" id="password"
								[placeholder]="getPasswordPlaceholder()" (focus)="onPasswordFocus()"
								(blur)="onPasswordBlur()" />
							<label [class.floating]="shouldFloatPasswordLabel()" for="password">
								Password
							</label>
							<div class="password-toggle-icon" (click)="togglePassword('password')">
								<i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
							</div>
						</div>
						<small *ngIf="form.controls['password'].invalid && form.controls['password'].touched"
							class="text-danger smaller-text">Must be at least 8 characters.</small>
					</div>

					<div class="col-md-10 offset-md-1 mb-3">
						<div class="floating-label-wrapper">
							<i class="bi bi-lock input-icon"></i>

							<input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
								class="form-control floating-input" id="confirmPassword"
								[placeholder]="getConfirmPasswordPlaceholder()" (focus)="onConfirmPasswordFocus()"
								(blur)="onConfirmPasswordBlur()" />
							<label [class.floating]="shouldFloatConfirmPasswordLabel()" for="confirmPassword">
								Confirm Password
							</label>
							<div class="password-toggle-icon" (click)="togglePassword('confirmPassword')">
								<i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
							</div>


						</div>
						<small *ngIf="form.hasError('passwordMismatch') && form.controls['confirmPassword'].touched"
							class="text-danger smaller-text">Passwords do not match!</small>
					</div>

					<div class="col-md-10 offset-md-1 mt-4">
						<button type="submit" class="btn-signup" [disabled]="form.invalid">
							Save New Password
						</button>
					</div>

					<div class="text-center mt-3 login-font">
						Remember old password? <a href="/login">Login</a>
					</div>
				</form>
			</div>
		</div>
	</div>
</ng-template>